<template>
  <div class="bz-picker">
    <div class="bz-refine-note">
      <i class="material-icons" style="font-size:15px;line-height:1;">table_chart</i>
      <span>This report benchmarks <b>your numbers</b> against industry data. Pick a saved input set — or create one right here.</span>
    </div>

    <div v-if="loading" class="bz-empty">Loading your saved input sets…</div>
    <div v-else-if="!sets.length && !creating" class="bz-empty">
      No saved input sets yet — create your first one below. Line-item detail can be added later inside the report.
    </div>
    <div v-else class="bz-inputs-list">
      <div v-for="s in sets" :key="s.id" class="bz-row" :class="{ sel: selected && selected.id === s.id }"
        @click="$emit('select', { set: s, method: 'existing' })">
        <span class="bz-radio" :class="{ on: selected && selected.id === s.id }">
          <i v-if="selected && selected.id === s.id" class="material-icons" style="font-size:12px;line-height:1;">check</i>
        </span>
        <div class="bz-row-main">
          <span class="bz-row-name">{{ s.name }}</span>
          <span class="bz-crumb">{{ s.description || s.desc || '' }}</span>
        </div>
        <span v-if="s.modified || s.updated_at" class="bz-area-meta">modified {{ (s.modified || s.updated_at || '').slice(0, 10) }}</span>
      </div>
    </div>

    <div v-if="creating" class="bz-newinput">
      <div class="bz-filter-h">
        <i class="material-icons" style="font-size:15px;line-height:1;">post_add</i>New input set
      </div>
      <div class="bz-newinput-grid">
        <label class="bz-field"><span>Name</span>
          <input v-model="nName" placeholder="e.g. FY2026 full year" />
        </label>
        <label class="bz-field"><span>Description</span>
          <input v-model="nDesc" placeholder="e.g. Full year, all schedules" />
        </label>
      </div>
      <div class="bz-newinput-foot">
        <span class="bz-carry-note">Line-item detail can be added later — the report opens with editable inputs.</span>
        <div style="display:flex;gap:8px;">
          <button class="bz-btn ghost sm" type="button" @click="creating = false">Cancel</button>
          <button class="bz-btn primary sm" type="button" :disabled="!nName.trim() || saving" @click="saveNew">
            {{ saving ? 'Saving…' : 'Save & use this set' }}
          </button>
        </div>
      </div>
    </div>
    <button v-else class="bz-btn ghost sm" style="align-self:flex-start;" type="button" @click="creating = true">
      <i class="material-icons" style="font-size:15px;line-height:1;">add</i>New input set
    </button>
  </div>
</template>

<script>
// "Your data" step — kills the go-to-Saved-Inputs-and-refresh dead-end.
// Lists via POST /user/my_data/all; inline create via POST /user/my_data/add.
import { fetchMyDataSets, createMyDataSet } from './model';
import { trackReportInputsCreated } from './analytics';

export default {
  name: 'inputs-step',
  props: {
    selected: { type: Object, default: null },
    product: { type: String, required: true },
    preselectId: { type: [String, Number], default: null },
  },
  data() {
    return { sets: [], loading: false, creating: false, saving: false, nName: '', nDesc: '' };
  },
  async created() {
    this.loading = true;
    try {
      this.sets = await fetchMyDataSets();
      if (this.preselectId) {
        const hit = this.sets.find((s) => String(s.id) === String(this.preselectId));
        if (hit) this.$emit('select', { set: hit, method: 'existing', silent: true });
      }
    } catch (e) {
      this.sets = [];
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async saveNew() {
      if (this.saving) return;
      this.saving = true;
      try {
        await createMyDataSet(this.nName.trim(), this.nDesc.trim());
        trackReportInputsCreated(this.product, [this.nName, this.nDesc].filter((x) => x.trim()).length);
        // reload so the new set carries its real server id
        this.sets = await fetchMyDataSets();
        const mine = this.sets.find((s) => s.name === this.nName.trim()) || this.sets[0];
        this.creating = false;
        this.nName = '';
        this.nDesc = '';
        if (mine) this.$emit('select', { set: mine, method: 'created_inline' });
      } catch (e) {
        this.$store.dispatch('alerts/error', 'Could not create the input set. Please try again or use Saved Inputs.');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
